import { Link, useLocation } from "react-router-dom";
import { activeLink } from "../../../helpers/Helper";

export default function SubNavMission() {
   const location = useLocation();
   return (
      <div className="filterArea bg-white pt-5 mb-5">
         <h3 className="page-title">ORDRE DE MISSION</h3>

         <div className="d-flex  justify-content-between bd-highlight border-bottom mb-3">

            <div className="p-2 d-flex bd-highlight hide4mobile">
               <ul className="searchCategory">
               <li><Link className={activeLink(location.pathname, '/bibliotheque/missions/ordres')} to="/bibliotheque/missions/ordres">ORDRES MISSIONS</Link></li>
               <li><Link className={activeLink(location.pathname, '/bibliotheque/missions/profils')} to="/bibliotheque/missions/profils">PROFILS MISSIONS</Link></li>
                  <li><Link className={activeLink(location.pathname, '/bibliotheque/missions/personnels')} to="/bibliotheque/missions/personnels">PERSONNEL MISSIONS</Link></li>
               </ul>
            </div>
         </div>
      </div>
   );
}